import { call, put, takeLatest, select } from 'redux-saga/effects';
import {
  GET_NOTES_REQUEST,
  GET_NOTES_SUCCESS,
  GET_NOTES_FAILURE,
  SAVE_NOTE_REQUEST,
  SAVE_NOTE_SUCCESS,
  SAVE_NOTE_FAILURE,
  DELETE_NOTES_REQUEST,
  DELETE_NOTES_SUCCESS,
  DELETE_NOTES_FAILURE,
} from './actions';
import { goBack } from 'connected-react-router';
import { tokenSelector, emailSelector } from '../Main/reducer';
import { get, post, del } from '../../utils/api';
import { selectedIdsSelector } from './reducer';
import ReactGA from 'react-ga';
import { handleApiError } from '../../utils/handleApiError';
import swal from 'sweetalert';
import { toast } from 'react-toastify';

function* getNotes() {
  try {
    const token = yield select(tokenSelector);
    const notes = yield call(get, `/notes/get`, token);
    const status = notes.status;

    let notesData = [];
    if (status === 200) {
      notesData = notes?.data?.notes?.length > 0 ? notes.data.notes : [];
    } else if (status === 404) {
      notesData = [];
    } else {
      throw new Error('Unexpected status code');
    }
    yield put({ type: GET_NOTES_SUCCESS, payload: notesData });
  } catch (error) {
    if (error?.response?.status !== 404) {
      yield handleApiError(error, GET_NOTES_FAILURE);
    } else {
      yield put({ type: GET_NOTES_SUCCESS, payload: [] });
    }
  }
}

function* saveNote({ payload }) {
  try {
    const token = yield select(tokenSelector);
    const email = yield select(emailSelector);
    const requestData = {
      ...(payload.id && { noteId: payload.id }),
      title: payload.title,
      text: payload.text,
      isComprehensionRequested: payload.comprehension,
      isSuperBillRequested: payload.superBill,
    };

    const response = yield call(
      post,
      `/notes/create-or-update`,
      requestData,
      token
    );
    const note = response.data.note;
    yield put(goBack());
    yield put({
      type: SAVE_NOTE_SUCCESS,
      payload: {
        id: note.id,
        title: note.title,
        text: note.text,
        date: note.updated_at,
        comprehension: note.comprehension,
        superBill: note.super_bill,
      },
    });
    if (payload.id) {
      toast.info(`Note Updated!`);
    } else {
      toast.info(`Note Saved!`);
    }

    ReactGA.event({
      category: 'dictation_web',
      action: 'note_save',
      label: email.replace('@', '[at]'),
    });
  } catch (error) {
    yield handleApiError(error, SAVE_NOTE_FAILURE);
  }
}

function* deleteNotes() {
  try {
    const token = yield select(tokenSelector);
    const selectedIds = yield select(selectedIdsSelector);
    const ids = { noteIds: selectedIds };
    if (ids.noteIds && ids.noteIds.length > 0) {
      yield call(del, `/notes/delete`, token, ids);
      yield put({ type: DELETE_NOTES_SUCCESS });
      if (ids.noteIds.length === 1) {
        toast.info(`Note Deleted!`);
      } else {
        toast.info(`Notes Deleted!`);
      }
    } else {
      yield put({ type: DELETE_NOTES_FAILURE });
      yield call(swal, 'Warning', 'Please select a note', 'warning');
    }
  } catch (error) {
    yield handleApiError(error, DELETE_NOTES_FAILURE);
  }
}

export default [
  takeLatest(GET_NOTES_REQUEST, getNotes),
  takeLatest(SAVE_NOTE_REQUEST, saveNote),
  takeLatest(DELETE_NOTES_REQUEST, deleteNotes),
];
